import { useEffect, useState } from 'react';

/**
 * useScrolledPast — boolean "is window.scrollY > threshold?", coalesced onto a
 * requestAnimationFrame so the scroll listener never fires faster than the
 * renderer can keep up. Only re-renders when the boolean crosses the threshold.
 *
 * Used by HeaderShell to drive both the standard scroll-aware border tint and
 * the homepage's blur→opaque perf swap.
 */
export function useScrolledPast(threshold: number): boolean {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = (): void => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setScrolled(window.scrollY > threshold);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
